import {
  CLEAR_VIDEO_CATEGORIES,
  SET_VIDEO_CATEGORIES,
  SET_VIDEO_CATEGORIES_MOVEMENT,
  SET_VIDEO_CATEGORIES_ASSESSMENT,
  SET_PARENT_VIDEO_CATEGORIES,
} from 'store/types/video-catergory';

export const setVideoCategories = (videoCategories) => {
  return {
    type: SET_VIDEO_CATEGORIES,
    payload: videoCategories,
  };
};

export const setVideoCategoriesMovement = (videoCategoriesMovement) => {
  return {
    type: SET_VIDEO_CATEGORIES_MOVEMENT,
    payload: videoCategoriesMovement,
  };
};

export const setVideoCategoriesAssessment = (videoCategoriesAssessment) => {
  return {
    type: SET_VIDEO_CATEGORIES_ASSESSMENT,
    payload: videoCategoriesAssessment,
  };
};

export const clearVideoCategories = () => {
  return {
    type: CLEAR_VIDEO_CATEGORIES,
    payload: null,
  };
};

export const setParentVideoCategories = (parentVideoCategories) => {
  return {
    type: SET_PARENT_VIDEO_CATEGORIES,
    payload: parentVideoCategories,
  };
};
